import { useEffect, useMemo } from 'react';

import { Stack, Typography } from '@mui/material';
import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';

import { IAddressInfo, IPoint } from '@/models';
import { getAddressInfoCoordinates, getMatchingAreaMaps } from '@/services';
import { useDataStore } from '@/store';

interface AreaMapLabelsProps {
  addressInfo?: IAddressInfo;
}

export const AreaMapLabels = ({ addressInfo }: AreaMapLabelsProps) => {
  const { beats, fetchBeats } = useDataStore();

  useEffect(() => {
    fetchBeats();
  }, [fetchBeats]);

  const areaMaps = useMemo(() => {
    const coordinates = getAddressInfoCoordinates(addressInfo);
    if (!coordinates) return [];
    const point: IPoint = {
      type: 'Point',
      coordinates: [coordinates.lng, coordinates.lat],
    };
    return getMatchingAreaMaps(beats, point);
  }, [beats, addressInfo]);

  if (!areaMaps.length) return null;

  return (
    <MapControl position={ControlPosition.TOP_LEFT}>
      <Stack spacing={0.5} sx={{ ml: 1, mt: 1 }} alignItems="flex-start">
        {areaMaps.map((areaMap) => (
          <Typography
            key={areaMap._id}
            sx={{
              px: 1,
              py: 0.25,
              fontSize: '0.75rem',
              color: 'text.primary',
              backgroundColor: 'background.paper',
              border: '1px solid',
              borderColor: 'background.default',
              borderRadius: '4px',
              boxShadow: 1,
            }}
          >
            {areaMap.name}
          </Typography>
        ))}
      </Stack>
    </MapControl>
  );
};
